import BlogRightSidebarContainer from "../../../../components/pages/blog/blogPage/BlogRightSidebar";

const BlogRightSidebar = () => {
  return <BlogRightSidebarContainer />;
};

export default BlogRightSidebar;
